import { render } from "./IconInfo.vue?vue&type=template&id=181254d9&scoped=true"
const script = {}

import "./IconInfo.vue?vue&type=style&index=0&id=181254d9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181254d9"]])

export default __exports__